import { compose, withState } from 'recompose';

import RadioButtonView from './RadioButtonView';

export default compose(
  withState('status', 'setRadio', false),
)(RadioButtonView);
